import { ReactNode, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import './AdminWrapper.scss'
import AdminSidebar from 'BoostXpressAdmin/Layout/AdminSidebar/AdminSidebar'
import AdminHeaderBar from 'BoostXpressAdmin/Layout/AdminHeaderBar/AdminHeaderBar'

interface AdminWrapperProps {
  title?: string
  sidebarContent?: ReactNode
  brandLogo?: string
  brandName?: string
}

const AdminWrapper = ({
  title = 'BoostXpress Admin',
  sidebarContent,
  brandLogo,
  brandName,
}: AdminWrapperProps) => {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  useEffect(() => {
    if (!isMobileMenuOpen) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsMobileMenuOpen(false)
      }
    }

    window.addEventListener('keydown', handleEscape)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleEscape)
    }
  }, [isMobileMenuOpen])

  return (
    <div className='admin-shell boostxpress-admin-shell'>
      <aside
        className={`admin-shell__sidebar ${isMobileMenuOpen ? 'admin-shell__sidebar--open' : ''}`}
      >
        <AdminSidebar
          onNavigate={() => setIsMobileMenuOpen(false)}
          navigation={sidebarContent}
          brandLogo={brandLogo}
          brandName={brandName}
        />
      </aside>

      {isMobileMenuOpen ? (
        <button
          type='button'
          className='admin-shell__backdrop'
          aria-label='Close navigation menu'
          onClick={() => setIsMobileMenuOpen(false)}
        />
      ) : null}

      <div className='admin-shell__main'>
        <AdminHeaderBar title={title} onMenuClick={() => setIsMobileMenuOpen(true)} />
        <main className='admin-shell__content'>
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AdminWrapper
